/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { Account, accountSchema } from './account';

export interface Data2 {
  account: Account[];
}

export const data2Schema: Schema<Data2> = object({
  account: ['Account', array(lazy(() => accountSchema))],
});
